import { render, staticRenderFns } from "./Consignee.vue?vue&type=template&id=562dbc1e&"
import script from "./Consignee.vue?vue&type=script&lang=js&"
export * from "./Consignee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports